import React, { useState } from "react";
import whitelogo from "../../../images/logo/logo-navbar.png";
import { Link } from "react-router-dom";
import navbarData from "../../../data/navbar.json";
import emailjs from "emailjs-com";
import axiosClient from "../../../api/axios";

export default function Footer({ space, information }) {
  const [participantEmail, setParticipantEmail] = useState("");
  const [participantAlert, setParticipantAlert] = useState({
    show: false,
    type: "",
    message: "",
  });
  const [isParticipantLoading, setIsParticipantLoading] = useState(false);

  // Handle participant list submission
  const handleParticipantSubmit = async (e) => {
    e.preventDefault();
    setIsParticipantLoading(true);
    setParticipantAlert({ show: false, type: "", message: "" });

    try {
      await submitPrticipationListToBackend();

      await emailjs.send(
        "service_zgh2ksd",
        "template_cokkqp7",
        {
          email: participantEmail,
          status: "participant-list",
          message: "New participant list subscription",
        },
        "USX72MTx26hcTNM95"
      );

      setParticipantAlert({
        show: true,
        type: "success",
        message: "Thank you for joining our participant list!",
      });

      setParticipantEmail("");
    } catch (error) {
      setParticipantAlert({
        show: true,
        type: "danger",
        message: "Failed to subscribe. Please try again.",
      });
    } finally {
      setIsParticipantLoading(false);
    }
  };

  // Participation list
  const submitPrticipationListToBackend = async () => {
    try {
      const payload = {
        email: participantEmail,
      };

      const response = await axiosClient.post("/api/subscribers/", payload);
      console.log("Join Participation list success:", response.data);
      return response.data;
    } catch (error) {
      console.error(
        "Join Participation list  failed:",
        error.response?.data || error.message
      );
      throw error;
    }
  };

  return (
    <>
      <footer className="footer-section">
        {/* Participant List Section  */}

        {/* Participant List Section */}
        <div
          className="d-flex  justify-content-center"
          style={{
            position: "relative",
            marginTop: "-4rem", // moves it down into the blue zone
            marginBottom: "-4rem",
            marginLeft: "2rem",
            marginRight: "2rem",
            zIndex: 5,
          }}
        >
          <div
            className="gray-light-bg shadow-lg pt-3 pb-3 pl-4 pr-4 text-center"
            style={{
              borderRadius: "24px",
              maxWidth: "700px",
              width: "100%",
            }}
          >
            <h4 className="mb-1" style={{ fontWeight: 700 }}>
              Join Our Participant List
            </h4>
            {/* <p className="text-muted mb-1">
              Stay updated with our latest clinical research opportunities and
              news.
            </p> */}

            {participantAlert.show && (
              <div
                className={`alert alert-${participantAlert.type} alert-dismissible fade show`}
                role="alert"
              >
                {participantAlert.message}
                <button
                  type="button"
                  className="close"
                  onClick={() =>
                    setParticipantAlert({ show: false, type: "", message: "" })
                  }
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            )}

            <form onSubmit={handleParticipantSubmit}>
              <div className="input-group">
                <input
                  type="email"
                  className="form-control px-4 py-3"
                  placeholder="Enter your email address"
                  value={participantEmail}
                  onChange={(e) => setParticipantEmail(e.target.value)}
                  required
                  disabled={isParticipantLoading}
                  style={{
                    borderTopLeftRadius: "50px",
                    borderBottomLeftRadius: "50px",
                    borderRight: "none",
                  }}
                />
                <div className="input-group-append">
                  <button
                    type="submit"
                    className="btn text-white px-4 py-3"
                    disabled={isParticipantLoading}
                    style={{
                      borderTopRightRadius: "50px",
                      borderBottomRightRadius: "50px",
                      background: "linear-gradient(135deg, #232c97, #4c57e6)",
                      border: "none",
                      minWidth: "100px",
                    }}
                  >
                    {isParticipantLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm mr-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Joining...
                      </>
                    ) : (
                      "Join"
                    )}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div
          className={`footer-top background-img-2 ${
            space ? "pt-150" : "pt-60"
          }`}
          style={{
            backgroundImage:
              "linear-gradient(to right, var(--color-76), var(--color-81), var(--color-86), var(--color-63), var(--color-67))",
          }}
        >
          <div className="container">
            <div className="row justify-content-between">
              <div className="col-sm-12 col-md-4">
                <div className="footer-nav-wrap text-white">
                  <img
                    src={information?.footer_logo_url}
                    alt="footer logo"
                    width="200"
                    className="img-fluid mb-3"
                  />
                  <p>{information?.description}</p>
                </div>
              </div>

              <div className="col-sm-12 col-md-3 col-lg-2">
                <div className="footer-nav-wrap text-white">
                  <h5 className="mb-3 text-white">Company</h5>
                  <ul className="list-unstyled support-list">
                    {navbarData.map((data) => (
                      <li key={data.id} className="mb-2">
                        <Link to={data.link}>{data.name}</Link>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="col-sm-12 col-md-4 col-lg-3">
                <div className="footer-nav-wrap text-white">
                  <h5 className="mb-3 text-white">Location</h5>
                  <ul className="list-unstyled support-list">
                    <li className="mb-2 d-flex align-items-center">
                      <span className="ti-location-pin mr-2"></span>
                      {information?.location}
                      <br />
                      {information?.state}
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span className="ti-mobile mr-2"></span>
                      {information?.phone}
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span className="ti-email mr-2"></span>
                      {information?.email}
                    </li>
                    <li className="mb-2 d-flex align-items-center">
                      <span className="ti-world mr-2"></span>
                      {information?.website}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-bottom border-gray-light mt-5 py-3">
            <div className="container">
              <div className="row">
                <div className="col-md-6 col-lg-7">
                  <div className="copyright-wrap small-text">
                    <p className="mb-0 text-white">© BM Consulting</p>
                  </div>
                </div>
                <div className="col-md-6 col-lg-5">
                  {/* <div className="terms-policy-wrap text-lg-right text-md-right text-left">
                    <ul className="list-inline">
                      <li className="list-inline-item">
                        <a className="small-text" href="#/">
                          Terms
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="small-text" href="#/">
                          Security
                        </a>
                      </li>
                      <li className="list-inline-item">
                        <a className="small-text" href="#/">
                          Privacy Policy
                        </a>
                      </li>
                    </ul>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
